import { History, Location } from "history";
import { connect } from "react-redux";

import {
  hasExpiredSubscriptionForCourse,
  hasExpiredSubscriptionForSection,
  hasNoSubscriptionForCourse,
  hasNoSubscriptionForSection
} from "seneca-common/features/course/state/selectors/meta";

import {
  getCourseIdFromInvalidSubscriptionForCourseState,
  getSectionIdFromInvalidSubscriptionForSectionState,
  redirectedFromInvalidSubscriptionForCourse,
  redirectedFromInvalidSubscriptionForSection
} from "features/classroom/routes/links";
import { getHelpLinkRegionCode } from "features/regions/selectors";

import ExpiredSubscriptionForCourseMessage from "../components/ExpiredSubscriptionForCourseMessage";
import NoSubscriptionForCourseMessage from "../components/NoSubscriptionForCourseMessage";

const MESSAGES = Object.freeze({
  NO_SUBSCRIPTION: "NO_SUBSCRIPTION",
  EXPIRED_SUBSCRIPTION: "EXPIRED_SUBSCRIPTION"
});

type OwnProps = {
  location: Location;
  history: History;
  backLink?: string;
  linkToUpgrade?: string;
};

type InjectedProps = {
  closeModal: () => void;
  onBackClick: () => void;
  messageType: keyof typeof MESSAGES;
};

type NoSubscriptionInjectedProps = InjectedProps & {
  messageType: "NO_SUBSCRIPTION";
};

type ExpiredSubscriptionInjectedProps = InjectedProps & {
  messageType: "EXPIRED_SUBSCRIPTION";
};

type Props =
  | NoSubscriptionInjectedProps
  | ExpiredSubscriptionInjectedProps
  | {
      messageType: null;
    };

function mapStateToProps(
  state: any,
  { location, history, backLink }: OwnProps
) {
  const goBack = () => history.replace(backLink || "");

  const commonProps = {
    closeModal: goBack,
    onBackClick: goBack,
    locale: getHelpLinkRegionCode(state)
  };

  if (
    redirectedFromInvalidSubscriptionForCourse(location) ||
    redirectedFromInvalidSubscriptionForSection(location)
  ) {
    const courseId = getCourseIdFromInvalidSubscriptionForCourseState(location);
    const sectionId =
      getSectionIdFromInvalidSubscriptionForSectionState(location);

    if (
      hasNoSubscriptionForCourse(state, courseId!) ||
      hasNoSubscriptionForSection(state, sectionId!)
    ) {
      return { ...commonProps, messageType: MESSAGES.NO_SUBSCRIPTION as any };
    } else if (
      hasExpiredSubscriptionForCourse(state, courseId!) ||
      hasExpiredSubscriptionForSection(state, sectionId!)
    ) {
      return {
        ...commonProps,
        messageType: MESSAGES.EXPIRED_SUBSCRIPTION as any
      };
    }
  }

  return {
    messageType: null
  };
}

function InvalidSubscriptionMessageRenderer({
  messageType,
  ...otherProps
}: Props) {
  switch (messageType) {
    case MESSAGES.NO_SUBSCRIPTION:
      return <NoSubscriptionForCourseMessage {...otherProps} />;

    case MESSAGES.EXPIRED_SUBSCRIPTION:
      return <ExpiredSubscriptionForCourseMessage {...otherProps} />;

    default:
      return null;
  }
}

const InvalidSubscriptionRedirectMessage = connect(mapStateToProps)(
  InvalidSubscriptionMessageRenderer
);

export default InvalidSubscriptionRedirectMessage;
